import { ListItemButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { OptionButton as OptionButtonBase } from '../../styles';

export const Wrapper = styled(ListItemButton)``;

export const OptionButton = styled(OptionButtonBase)``;
